import React from 'react';
import { Star, Quote } from 'lucide-react';

const TestimonialsSection = ({ testimonials }) => {
  if (!testimonials || testimonials.length === 0) return null;

  return (
    <section id="testimonials" className="py-32 bg-[#0d0d0d] relative" data-testid="testimonials-section">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#C9A55C]/30 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-20 space-y-6">
          <span className="text-sm font-semibold tracking-[0.3em] uppercase text-[#C9A55C]">
            Témoignages
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-white">
            Ils ont choisi HELP'ADN
          </h2>
          
          {/* Rating */}
          <div className="flex items-center justify-center gap-3 pt-4">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-[#C9A55C] text-[#C9A55C]" />
              ))}
            </div>
            <span className="text-sm text-white/50">4.9/5 sur 50+ avis</span>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="luxury-card p-10 relative"
              data-testid={`testimonial-${index}`}
            >
              {/* Quote icon */}
              <Quote className="absolute top-8 right-8 w-12 h-12 text-[#C9A55C]/10" />
              
              <div className="space-y-6 relative">
                {/* Stars */}
                <div className="flex gap-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-[#C9A55C] text-[#C9A55C]" />
                  ))}
                </div>

                {/* Content */}
                <p className="text-white/80 leading-relaxed text-lg italic">
                  "{testimonial.content}"
                </p>

                {/* Author */}
                <div className="flex items-center gap-4 pt-6 border-t border-[#C9A55C]/20">
                  <div className="w-14 h-14 border border-[#C9A55C]/50 flex items-center justify-center">
                    <span className="text-xl font-serif font-bold text-[#C9A55C]">
                      {testimonial.name.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <p className="font-semibold text-white">{testimonial.name}</p>
                    <p className="text-sm text-[#C9A55C]/70">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
